var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"credit"},[(_vm.website)?_c('div',[_c('a',{attrs:{"href":_vm.website,"target":"_blank"}},[_vm._v(_vm._s(_vm.website))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }